import { createElement } from 'react';

import { resolveFaIcon } from '@/lib/fa-icons';
import { cn } from '@/lib/utils';

import { accentSurfaceStyle } from '../lib/faq-format';

interface FaqCategoryIconProps {
  /** Nombre de icono FontAwesome guardado en la base de datos. */
  icono: string;
  /** Color hexadecimal de la categoría. */
  color: string;
  className?: string;
}

/** Chip de icono de una categoría del FAQ, con el color definido en el panel. */
export function FaqCategoryIcon({ icono, color, className }: FaqCategoryIconProps) {
  return (
    <span
      className={cn(
        'flex size-9 shrink-0 items-center justify-center rounded-xl bg-brand-50 text-brand-600',
        className,
      )}
      style={accentSurfaceStyle(color)}
    >
      {createElement(resolveFaIcon(icono), { className: 'size-4.5', 'aria-hidden': true })}
    </span>
  );
}
